const camelize = string => string.replace(/_(.)/g, g => g[1].toUpperCase());

const underscore = string => string.replace(/([a-z])([A-Z])/g, g => `${g[0]}_${g[1].toLowerCase()}`);

export { camelize, underscore };
